import { httpClient } from 'shared/api/http-client'
import { RegisterFormInterface } from '../types/post-register-interface'
import { REGISTER_API } from './constants'

export function register(body: RegisterFormInterface) {
  return httpClient.post(REGISTER_API, body)
}
